import React from 'react';

import '../Login/index.css';

export default function Login() {
    return (<div>Acesse o módulo Gestão de Usuários para Entrar</div>)
}
